import { AxiosResponse } from "axios";

/**
 * An Axios promise wrapper. Used to facilitate fetch-then-render.
 *
 * @param callback A promise for an Axios response.
 * @returns A function to return the Axios response.
 */
export const axiosSafePromise = (promise: Promise<AxiosResponse | undefined>): () => AxiosResponse | undefined => {
  let status: string = 'pending';
  let result: AxiosResponse | undefined;

  const suspender = promise.then(
    (res) => {
      status = 'success';
      result = res;
    },
    (err) => {
      status = 'failure';
      result = err;
    },
  );
  
  return () => {
    switch (status) {
      case 'pending':
        throw suspender;
      case 'failure':
        throw result;
      default:
        return result;
    }
  }
}
